"use client";

export default function Error({ error, reset }) {
  if (error) console.error("Campaign page error:", error);
  return (
    <div className="max-w-md mx-auto p-4">
      <div className="rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
        Something went wrong while loading this campaign.
      </div>
      <button
        onClick={() => reset()}
        className="mt-3 px-3 py-2 rounded-md bg-emerald-500 text-white text-sm"
      >
        Try again
      </button>
    </div>
  );
}
